import { Injectable } from '@angular/core';
import { IIdentify } from 'src/app/models/identify.interface';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { ILanguages } from 'src/app/models/languages.interface';
import { MonitoringService } from '../../utility/monitoring/monitoring.service';
import { IBalance } from 'src/app/models/balance.interface';
import {UrlControllerService} from '../../url-controller.service';
import {Store} from '@ngrx/store';
import {IAppState} from '../../../store/state/app.state';
import {error} from 'protractor';

/**
 * Service with http call to populate language and config cID sections
 */
@Injectable({
  providedIn: 'root'
})
export class IdentifyService extends UrlControllerService{

  /**
   * Costructor service
   * @param http take http client module
   * @param monitoringService service to log and monitoring
   */
  constructor(private http: HttpClient,
    private monitoringService: MonitoringService, public _store: Store<IAppState>) {
    super(_store);
    // this.apiUrl = super.getUrl();
  }

  /**
   * Call service and return observable of IIdentify
   * @returns Observable<IIdentify>
   */
  getIdentify(): Observable<IIdentify> {
    return this.http.get<IIdentify>(this.apiUrlSelected + 'rest/identify/online')
      .pipe(
        catchError(this.monitoringService.handleError<IIdentify>('getIdentify', null))
      );
  }


  /**
   * Call service and return observable of IIdentify
   * @returns Observable<IIdentify>
   */
  getBalance(token: string): Observable<IBalance> {
    return this.http.get<IBalance>(this.apiUrlSelected + 'rest/online/balance/' + token)
      .pipe(
        catchError(
            this.monitoringService.handleError<IBalance>(
            'getBalance',
            {
                balance: 0,
                bonus: [],
                freebet: null,
                currency: null,
                description: 'GENERAL.PARTNER_UNREACHABLE',
                language: null,
                ret_code: 2024
            })
        )
      );
  }

  /**
   * Call service and return observable of ILanguages
   * @returns Observable<ILanguages>
   */
  getLanguages(): Observable<ILanguages> {
    return this.http.get<ILanguages>(`${this.apiUrlSelected}rest/locale/languages/cesare/9f90a865bfb83943918629513c450ff1`)
      .pipe(
        // TODO spostare il filtro in un pipe lato template
        map((x: any) => {
          if (x.languages) {
          x.languages.filter(y => y.show === '1');
          }
          return x;
        }),
        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError<ILanguages>('getLanguage', {languages : []})) // then handle the error
      );
  }

}
